module.exports = __webpack_public_path__ + "img/logoFixmin.78bb4228.png";